export enum ProductOrderBy {
  CreatedAt = 'createdAt',
  OrderIndex = 'orderIndex',
}

export enum MarkReadType {
  Product = 'product',
  Collabs = 'collabs',
}

// ============================================================================
// ENUMS
// ============================================================================

export enum ProductInclude {
  VersionIds = 'VersionIds',
  CollabIds = 'CollabIds',
  UnreadCollabCount = 'UnreadCollabCount',
  LatestVersionNumber = 'LatestVersionNumber',
  SubproductIds = 'SubproductIds',
  UnseenSubproductCount = 'UnseenSubproductCount',
  HasUnreadContentVersion = 'HasUnreadContentVersion',
  AttachedFiles = 'AttachedFiles',
}

export enum ProductListOrderBy {
  CreatedAt = 'created_at',
  OrderIndex = 'order_index',
}

/** product.type */
export enum ProductType {
  Content = 'Content',
  Collection = 'Collection',
  Folder = 'Folder',
}

/** product.role — behavioral overlay; null for a plain node */
export enum ProductRole {
  Decision = 'Decision',
}

/** product.marked_as */
export enum MarkedAs {
  Pending = 'Pending',
  InProgress = 'InProgress',
  Done = 'Done',
  Archived = 'Archived',
  Disputed = 'Disputed',
}

export enum ProductActorRole {
  Owner = 'owner',
  Opposition = 'opposition',
}

export const PRODUCT_TYPE_VALUES = Object.freeze(Object.values(ProductType));

export const MARKED_AS_VALUES = Object.freeze(Object.values(MarkedAs));

export enum ProductStatus {
  Pending = 'pending',
  InProgress = 'inProgress',
  Done = 'done',
}

// ============================================================================
// SHARED FILTER TYPES
// ============================================================================

export enum ProductOwnerScope {
  Current = 'current',
}

export enum ProductTreeDepth {
  Max = 'max',
}

export enum ProductTreeDetailLevel {
  Shallow = 'shallow',
  Default = 'dynamic',
  Max = 'max',
}

export enum ProductIncludeField {
  Content = 'content',
  BriefHistory = 'briefHistory',
  FullDescription = 'fullDescription',
}
